import StepExecutor from "../../StepExecutor";
import UrlBuilder from "./UrlBuilder";
import SocketManager from "./socket/SocketManager";
import ResultManager from "./result/ResultManager";
import Logger from "../../../utils/Logger";
import EQmScoreStepDone from "../../../../public-apis/onclick/EQmScoreStepDone";
import MscoreBestServer from "./MscoreBestServer"
import * as KpiMapper from "../../../gateway/service/modules/kpi/mapper/KpiMapper";

export const STATUS_SUCCESS = 'success';
export const STATUS_FAILED = 'failed';
export const STATUS_CANCEL = 'canceled';
export const STATUS_DROP = 'drop';

/**
 * Represent a mScore step
 */
export default class MscoreStepExecutor extends StepExecutor {

    /**
     * @param {GpsManager} gpsManager GPS Manager to collect GPS info
     * @param {DeviceManager} deviceManager The device manager
     * @param {ConfigStepMscore} configuration server
     * @param {string} uid Unique id
     * @param {number} campaignId from configuration
     * @param {number} scenarioId identifier (should be the same for all step in a script)
     * @param {Map<string,string>} customFields A map of custom fields
     * @param {number} group identifier
     * @param {GatewayService} gatewayService gateway service
     */
    constructor(gpsManager, deviceManager, configuration, uid, campaignId, scenarioId, customFields, groupId, gatewayService) {
        super(configuration);
        this.gpsManager = gpsManager;
        this.uid = uid;
        this.urlBuilder = new UrlBuilder(uid, configuration, campaignId, scenarioId, customFields, groupId, deviceManager);
        this.direction = configuration.getDirection();
        this.volume = configuration.getVolume();
        this.log = configuration.isLogEnabled();
        this.socketManager = new SocketManager(gpsManager, this.urlBuilder, configuration.getSocketCount(), configuration.getDirection(), configuration.getTimeout(), gatewayService);
        this.resultManager = new ResultManager(this.urlBuilder);
        this.mscoreBestServer = new MscoreBestServer(this.configuration, this.urlBuilder);
        this.gatewayService = gatewayService;
    }

    /**
     *
     * @param {function} resolve
     * @param {function} reject
     * @param {function} progress
     */
    startInternal(resolve, reject, progress) {
        let gatewayInfos = {};
        const gatewayInfosCache = this.gatewayService.getCacheInfos();
        if (gatewayInfosCache) {
            gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.COMMON]);
            gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.BEGIN]);
            gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.END]);
            this.socketManager.gatewayInfos = gatewayInfosCache[KpiMapper.RAW];
        }

        let gatewayRetrieval = new Promise((resolve) => { // Create new promise because success is not mandatory to call operation
            this.gatewayService.getInfos().then((infos) => {
                gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.COMMON]);
                gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.BEGIN]);
                gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.END]);
                this.socketManager.gatewayInfos = infos[KpiMapper.RAW];
                resolve();
            }).catch((e) => {
                Logger.log(e);
                resolve();
            });
        });

        gatewayRetrieval.then(() => {
            return this.mscoreBestServer.bestServer()
        })
        .then((mScoreServerUrl) =>
            this.socketManager.start(progress, this.urlBuilder.buildTestUrl(mScoreServerUrl, this.gpsManager.get(), gatewayInfos), this.volume, mScoreServerUrl
        )
        .then((result) => {
            return this.resultManager.getResult(this.urlBuilder.buildResultUrl(result.mScoreServerUrl), result.results, result.mScoreServerUrl, this.configuration);
        }).then((result) => {
            if (this.isCancelled()) result.status = STATUS_CANCEL;
            if (this.isDropped()) result.status = STATUS_DROP;
            if (this.isFailed()) result.status = STATUS_FAILED;
            resolve(result);
        })).catch((error) => {
            Logger.log(error);
            resolve(new EQmScoreStepDone(STATUS_FAILED, this.direction, this.configuration.getService(), this.configuration.getModule()));
        });
    }

    stopInternal() {
        return this.socketManager.stop();
    }

    isDropped() {
        // EWA-48
        for (let socket of this.socketManager.sockets) {
            if (socket.httpStatus < 500 || socket.httpStatus > 599) {
                return false;
            }
        }

        return true;
    }

    isFailed() {
        // EWA-59
        for (let socket of this.socketManager.sockets) {
            if (!socket.hasFailed || socket.volume > 0) {
                return false;
            }
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/MscoreStepExecutor.js